import { API_BASE_URL } from "../../../config/constants/endpoints";
import useSWR from "swr";

export const useGetActiveFacilities = () => {
  const url = `/v1/facility?is_enable_booking=true`;
  const { data, mutate, error } = useSWR<FacilityResponse>(url);

  return { data, mutate, error, url };
};
